const AUTH_PARAMETERS = ["code", "state", "iss", "client_id"];

// Storage keys
const STORAGE_KEYS = {
  FILTER_SELECTIONS: "filterCardSelections",
  MOCK_USER: "oidc.user:http://localhost:1080/acm/oauth2/mau:isce"
} as const;

// Patterns for storage cleanup
const STORAGE_CLEANUP_PATTERNS = ["oidc.", "isce"] as const;

export { AUTH_PARAMETERS, STORAGE_KEYS, STORAGE_CLEANUP_PATTERNS };
